import {
    SET_FLY_OBJECT,
    SET_FLY_AREA
} from "./type.js";
export default {
    namespaced: true,
    state: {
        _7d:[]
    },
    mutations: {
        [SET_FLY_OBJECT](state, flyObject) {
            state.flyObject = flyObject
            sessionStorage.setItem("flyObject", flyObject);
        },
        [SET_FLY_AREA](state, flyArea) {
            state.flyArea = flyArea
            sessionStorage.setItem("flyArea", flyArea);
        },
    },
    actions: {
        [SET_FLY_OBJECT]({ commit }, flyObject) {
            commit(SET_FLY_OBJECT, flyObject);
        },
        [SET_FLY_AREA]({ commit }, flyArea) {
            commit(SET_FLY_AREA, flyArea);
        },
    },
};
